define('bizzabo/views/main/sponsors/EditSplashView',[
    'jquery',
    'backbone',
    'bizzabo/config',
    'bizzabo/consts',
    'bizzabo/models/Global',
    'bizzabo/views/UploadFileView',
    'bizzabo/views/UploadFileCloudinaryView',
    'hbars!bizzabo/templates/editSplash'
], function(
    $,
    Backbone,
    CONFIG,
    Consts,
    Global,
    UploadFileView,
    UploadFileCloudinaryView,
    template
    ) {

    var EditSplashView = Backbone.View.extend({

        events : {
            'click .uploadFile' : 'uploadImage'
        },

        switchImgTimeOut : undefined,
        currentImgIndex : 2,
        SWITCH_IMG_TIMEOUT : 3000, //millis
        isAnimationRunning : true,

        initialize : function() {
            this.model.on("change:splash-screen-url", this.renderLogo, this);
            this.initializeUploadCloudinaryView();
        },

        remove : function() {
            this.model.off("change:splash-screen-url", this.renderLogo, this);
            clearTimeout(this.switchImgTimeOut);
            this.off();
            this.cloudinary.remove();
            this.$el.remove();
            this.isAnimationRunning = false;
        },
        initializeUploadCloudinaryView : function() {
            this.cloudinary = new UploadFileCloudinaryView({
                cropping: 'server',
                cropping_aspect_ratio: 480/780,
                max_image_width: 480,
                max_image_height: 780,
                recommendedSize: 'Recommended image size: 480W X 780H. Must be JPG, GIF, or PNG and smaller than 750Kb'
            });
            this.listenTo(this.cloudinary, 'success', this.renderImage);
        },

        renderImage: function () {
            this.model.set('splash-screen-url', this.cloudinary.image);
            this.formLogoChanged();
        },

        renderSubViews : function() {
            this.$('.uploadFile').html(this.cloudinary.render().el);
        },

        render : function() {
            var source = _.extend(this.model.toJSON(), {
                upgradeUrlQuery: Global.modelPool.getServicePlan(this.model.id).upgradeUrlQuery()
            });
            var html = template(source);
            this.$el.html(html);

            this.renderLogo();
            this.renderSubViews();
            this.renderMsgs();
            return this;
        },

        renderLogo : function() {
            var animatingImgEls = this.$(".flippingImg" + this.currentImgIndex);
            var logoImages = this.$('img.splashImage');

            if (this.model && this.model.has('splash-screen-url')) {
                animatingImgEls.addClass("hide");

                var logoURL = this.model.get('splash-screen-url');
                logoImages.fadeOut('slow', function() {
                    logoImages.attr("src", logoURL).removeClass('hide').fadeIn('slow');
                });
            } else {
                animatingImgEls.removeClass("hide");
                logoImages.addClass("hide");
                this.isAnimationRunning = true;
                this.startAnimation();
            }
        },

        renderMsgs : function() {
            var eventId = this.model.get("id");
            var servicePlan = Global.modelPool.getServicePlan(eventId);

            var showNoServicePlanMsg = false;
            var showNoSplashMsg = !servicePlan.get("splash-screen") && !showNoServicePlanMsg;

            this.$(".noPackageMsg").toggleClass("hide", !showNoServicePlanMsg);
            this.$(".noSplashMsg").toggleClass("hide", !showNoSplashMsg);
        },

        formLogoChanged : function(data) {
            Backbone.trigger(Consts.Notifications.analytics.TRACK_EVENT, {
                category : 'Organizer Responses',
                action : 'Splash screen uploaded'
            });
        },

        startAnimation : function(context, forceStart) {
            if (_.isUndefined(context)) {
                context = this;
            }
            if (forceStart) {
                context.isAnimationRunning = true;
            }
            if (!context.isAnimationRunning) {
                return;
            }
            var currentImgEl = context.$(".flippingImg" + context.currentImgIndex);
            if (context.model && context.model.has('splash-screen-url')) {
                clearTimeout(context.switchImgTimeOut);
                currentImgEl.fadeOut(100);
                return;
            }

            context.currentImgIndex = (context.currentImgIndex + 1) % 3;
            var nextImgEl = context.$(".flippingImg" + context.currentImgIndex);

            nextImgEl.fadeIn(500, function() {
                currentImgEl.fadeOut(500, function() {
                    clearTimeout(context.switchImgTimeOut);
                    context.switchImgTimeOut = setTimeout(function() {
                        context.startAnimation(context);
                    }, context.SWITCH_IMG_TIMEOUT);

                });
            });
        },

        stopAnimation : function() {
            this.isAnimationRunning = false;
            clearTimeout(this.switchImgTimeOut);
        }
    });

    return EditSplashView;

});
